import { z } from 'zod';
import { roleSchema } from '../roles.js';
/**
 * GET /api/health — the Phase 0 vertical slice.
 *
 * Proves, in one round trip: Hosting rewrite -> Express function -> ID token
 * verification -> Firestore read -> security rules -> typed response.
 */
export const healthResponseSchema = z.object({
    ok: z.literal(true),
    uid: z.string().min(1),
    roles: z.array(roleSchema),
    /** Server time, ISO-8601. Useful for spotting clock skew from the client. */
    serverTime: z.string(),
    /** Echoed back so a user can quote it when reporting a problem. */
    requestId: z.string(),
});
//# sourceMappingURL=health.js.map